/**
 * Promotion subscriptions registry to keep track of active subscriptions per client.
 * Active subscription contains service instance and list of channels the client is subscribed to.
 *
 * @class SubscriptionsRegistry
 * @memberof Mojito.Services.Promotions
 * @private
 */
export default class SubscriptionsRegistry {
    constructor() {
        this.subscriptions = {};
    }

    addSubscription(clientId, info) {
        this.subscriptions[clientId] = info;
    }

    getSubscription(clientId) {
        return this.subscriptions[clientId];
    }

    removeSubscription(clientId) {
        const subscription = this.subscriptions[clientId];
        delete this.subscriptions[clientId];
        return subscription;
    }

    reset() {
        this.subscriptions = {};
    }
}
